import styles from "./ChecklistModal.module.css";
import { X, Send } from "lucide-react";
import PDFIcon from "./pdf.png"
import { downloadChecklist } from "../../api/checklists.api";
import { useState } from "react";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { atualizarToken } from "../../api/assinatura.api";

function ChecklistModal({ thisChecklist, setIsOpen }) {
    const [isOpenSecondary, setIsOpenSecondary] = useState(false);
    const [id, setId] = useState(thisChecklist.tecnico.id)

    const parsedId = Number(id);


    const handleNewAssinagture = async () => {
        const payload = {
            ChecklistId: thisChecklist.id,
            UserId: isNaN(parsedId) ? id : null,
            TecnicoId: !isNaN(parsedId) ? parsedId : null,
        }

        await atualizarToken(payload)

        setIsOpen(false)
    }

    const handleDownload = async (idChecklist) => {
        try {
            const response = await downloadChecklist(idChecklist);

            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `checklist-${idChecklist}.pdf`);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Erro ao baixar PDF:", error);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.containerCheck}>
                <div className={styles.header}>
                    <h1>Checklist #{thisChecklist.id}</h1>
                    <X onClick={() => setIsOpen(false)} />
                </div>
                <div className={styles.containerInfosCheck}>
                    <div className={styles.inputs}>
                        <span>Placa do Carro</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.car.placa} />
                    </div>
                    <div className={styles.inputs}>
                        <span>Executor</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.user.name} />
                    </div>
                    <div className={styles.inputs}>
                        <span>Condutor Responsável</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.tecnico.name} />
                    </div>
                    <div className={styles.inputs}>
                        <span>Data</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.data} />
                    </div>
                    <div className={styles.inputs}>
                        <span>Hora</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.hora} />
                    </div>
                    <div className={styles.inputs}>
                        <span>Quilometragem</span>
                        <input type="text" className={styles.input} readOnly value={thisChecklist.quilometragem} />
                    </div>
                    <div className={styles.containerItens}>
                        <p>Itens checados:</p>
                        <div className={styles.itens}>

                            {thisChecklist.itens.map((item) => {
                                return item.problema === false ?
                                    <div className={styles.itensStatusOk}>
                                        <p>{item.item}</p>
                                        <span>Ok</span>
                                    </div>
                                    :
                                    <div className={styles.itensStatusErro}>
                                        <p>{item.item} </p>
                                        <input type="text" value={item.descricao} readOnly />
                                    </div>
                            })}
                        </div>

                    </div>
                    <div className={styles.inputs}>
                        <span>Observação:</span>
                        <textarea className={styles.textarea} readOnly value={thisChecklist.observacao}></textarea>
                    </div>

                </div>
                <div className={styles.buttons}>
                    <button onClick={() => setIsOpenSecondary(true)}>
                        <Send size={20} color="#fff" strokeWidth={1.5} />
                        Reenviar Checklist
                    </button>
                    <button onClick={() => handleDownload(thisChecklist.id)}>
                        <img src={PDFIcon} alt="" />
                        Exportar
                    </button>
                </div>
            </div>

            {isOpenSecondary && (<div className={styles.modal}>
                <div>
                    <div className={styles.select}>
                        <label>Para quem você deseja enviar um novo link para assinatura?</label>
                        <SelectRoot value={id} onValueChange={setId}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value={thisChecklist.tecnico.id}>{thisChecklist.tecnico.name}</SelectItem>
                                <SelectItem value={thisChecklist.user.id}>{thisChecklist.user.name}</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.buttonsModal}>
                        <button className={styles.button} onClick={() => handleNewAssinagture()}>Enviar Link</button>
                        <button className={styles.button} onClick={() => setIsOpenSecondary(false)}>Cancelar</button>
                    </div>
                </div>
            </div>)}
        </div>
    )
}

export default ChecklistModal;